// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { NormalService, NormalServiceT, verifyNormalService } from "./normal-service";
import {
  ServiceVariant,
  unionToServiceVariant,
  unionListToServiceVariant,
} from "./service-variant";
import { ValuedService, ValuedServiceT, verifyValuedService } from "./valued-service";

export class ElevatorServiceMessage implements flatbuffers.IUnpackableObject<ElevatorServiceMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ElevatorServiceMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsElevatorServiceMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: ElevatorServiceMessage,
  ): ElevatorServiceMessage {
    return (obj || new ElevatorServiceMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsElevatorServiceMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: ElevatorServiceMessage,
  ): ElevatorServiceMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ElevatorServiceMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  messageType(): ServiceVariant {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ServiceVariant.NONE;
  }

  message<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startElevatorServiceMessage(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addMessageType(builder: flatbuffers.Builder, messageType: ServiceVariant) {
    builder.addFieldInt8(0, messageType, ServiceVariant.NONE);
  }

  static addMessage(builder: flatbuffers.Builder, messageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, messageOffset, 0);
  }

  static endElevatorServiceMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // message
    return offset;
  }

  static createElevatorServiceMessage(
    builder: flatbuffers.Builder,
    messageType: ServiceVariant,
    messageOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    ElevatorServiceMessage.startElevatorServiceMessage(builder);
    ElevatorServiceMessage.addMessageType(builder, messageType);
    ElevatorServiceMessage.addMessage(builder, messageOffset);
    return ElevatorServiceMessage.endElevatorServiceMessage(builder);
  }

  unpack(): ElevatorServiceMessageT {
    return new ElevatorServiceMessageT(
      this.messageType(),
      (() => {
        const temp = unionToServiceVariant(this.messageType(), this.message.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
    );
  }

  unpackTo(_o: ElevatorServiceMessageT): void {
    _o.messageType = this.messageType();
    _o.message = (() => {
      const temp = unionToServiceVariant(this.messageType(), this.message.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
  }

  unpackFields(...fields: string[]): ElevatorServiceMessageT {
    const t = new ElevatorServiceMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("message_type")) {
      t.messageType = this.messageType();
    }
    if (fieldSet.has("message")) {
      t.message = (() => {
        const temp = unionToServiceVariant(this.messageType(), this.message.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    return t;
  }
}

export class ElevatorServiceMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public messageType: ServiceVariant = ServiceVariant.NONE,
    public message: NormalServiceT | ValuedServiceT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.message === null || this.message === undefined) {
      throw new Error('Required field "message" is not set');
    }
    const message = builder.createObjectOffset(this.message);

    return ElevatorServiceMessage.createElevatorServiceMessage(builder, this.messageType, message);
  }

  clone(): ElevatorServiceMessageT {
    const obj = new ElevatorServiceMessageT();
    obj.messageType = this.messageType;
    obj.message =
      this.message !== null && typeof (this.message as any).clone === "function"
        ? (this.message as any).clone()
        : this.message;
    return obj;
  }

  equals(other: ElevatorServiceMessageT): boolean {
    if (this.messageType !== other.messageType) return false;
    if (this.message !== null && other.message !== null) {
      if (typeof (this.message as any).equals === "function") {
        if (!(this.message as any).equals(other.message)) return false;
      } else if (this.message !== other.message) return false;
    } else if (this.message !== other.message) return false;
    return true;
  }
}

export function verifyElevatorServiceMessage(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, "message");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // NormalService
            {
              const o = verifier.readInt32(pos);
              verifyNormalService(verifier, pos + o);
            }
            break;
          case 2: // ValuedService
            {
              const o = verifier.readInt32(pos);
              verifyValuedService(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, "message");
  } finally {
    verifier.popDepth();
  }
}
